import './Article.scss';
import { useLocation } from 'react-router-dom';

const Article = (props) => {
  const location = useLocation();

  return (
    <div className='article-content'>
      <h2>{location.state.title}</h2>
      <p>{location.state.body}</p>
    </div>
  );
}

export default Article;